import { memo, useCallback, useMemo, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { List } from 'foundations-components/transitional/components/List';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MemoizedUploaderOptionsList = ({
  onUploadAvatarClick,
  onClearAvatarClick,
  renderButton
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const onOpenChange = useCallback(({
    target: {
      value
    }
  }) => {
    if (value !== isOpen) {
      setIsOpen(value);
    }
  }, [isOpen]);
  const popoverProps = useMemo(() => ({
    _distanceAdjustment: -30,
    onFocusLeave: () => {
      setIsOpen(false);
    },
    onMouseLeave: () => {
      setIsOpen(false);
    }
  }), []);
  const handleUploadAvatarClick = useCallback(() => {
    onUploadAvatarClick();
    setIsOpen(false);
  }, [onUploadAvatarClick]);
  const handleClearAvatarClick = useCallback(() => {
    onClearAvatarClick();
    setIsOpen(false);
  }, [onClearAvatarClick]);
  return /*#__PURE__*/_jsx(Dropdown, {
    "data-test-id": "avatar-upload-dropdown",
    arrowSize: "medium",
    Button: renderButton,
    open: isOpen,
    placement: "bottom",
    menuWidth: 168,
    onOpenChange: onOpenChange,
    popoverProps: popoverProps,
    children: /*#__PURE__*/_jsxs(List, {
      children: [/*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Button, {
          onClick: handleUploadAvatarClick,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "uiAddonAvatars.defaultUploader.upload"
          })
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Button, {
          onClick: handleClearAvatarClick,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "uiAddonAvatars.defaultUploader.clear"
          })
        })
      })]
    })
  });
};
export const UploaderOptionsList = /*#__PURE__*/memo(MemoizedUploaderOptionsList);